import { createContext } from "react";
import { CognitoIdentity, UserData } from "../Shared/UserData";
import { CredentialResponse } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { StateManager } from "../widgets/PartyState";






export const GetUserDataFromGoogleOAuth = async (cognito : CognitoIdentity): Promise<{error : boolean, userData : UserData | null, newUser : boolean, message : string}> => {
  const uri = '/api/user/getgoogle';
  const response = await fetch(uri, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body : JSON.stringify({cognito : cognito})
  });

  const json = await response.json();
  const error = json.error as boolean;
  const message = error ? json.message as string : '';
  const userData = error ? null : json.userData as UserData;
  const newUser = error ? false : json.newUser as boolean;
  return { error, newUser, userData, message};
}

export const GetUserDataFromFanboxOAuth = async (cognito : CognitoIdentity): Promise<{error : boolean, userData : UserData | null, newUser : boolean, message : string}> => {
  const uri = '/devapi/user/getfanbox';
  const response = await fetch(uri, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body : JSON.stringify({cognito : cognito})
  });

  const json = await response.json();
  const error = json.error as boolean;
  const message = error ? json.message as string : '';
  const userData = error ? null : json.userData as UserData;
  const newUser = error ? false : json.newUser as boolean;
  return { error, newUser, userData, message};
}

export const GoogleLoginHandler = (credentialResponse : CredentialResponse, stateManager : StateManager) => {
  console.log('Google log in Succeeded');
  //console.log(credentialResponse);


  const decodedJWT = jwtDecode(credentialResponse.credential ?? '') as any;
  const cognito : CognitoIdentity = {
      provider : 'Google',
      id : decodedJWT.sub,
      accessToken : credentialResponse.credential ?? '',
      email : decodedJWT.email,
      nickname : decodedJWT.name
  }

  stateManager.updateCognito(cognito);
}

export const GoogleLoginHandlerMock = (stateManager : StateManager) => {

  const dt = Math.round(Date.now() / 100000) % 1000000;
  const nickname = '@FanboxDev' + dt;
  const email = nickname.slice(1) + '@gmail.com';

  const cognito : CognitoIdentity = {
    provider : 'Fanbox',
    id : crypto.randomUUID(),
    accessToken : '',
    email : email,
    nickname : nickname
  }

  stateManager.updateCognito(cognito)
}

